import React, { useState, useEffect } from 'react';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import AppTextInput from '../../../../../@jumbo/components/Common/formElements/AppTextInput';
import { Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Select, InputLabel, FormHelperText } from '@material-ui/core';

import { CircularProgress } from '@material-ui/core';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';

import { getPrestadorPorRut, postCrearPersonl, } from 'services/api';

//import { Edit, Save } from '@material-ui/icons';
import { antiguedadList, findMostSimilarString, validateMail } from '../../ConstsAndUtils/utils';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

const unidad_funcional_list = [
  { "label": "Hospitalización Médico-Quirúrgico Adulto", "value": "Hospitalización Médico-Quirúrgico Adulto", "codigo": 1 },
  { "label": "Hospitalización Médico-Quirúrgico Pediátrica", "value": "Hospitalización Médico-Quirúrgico Pediátrica", "codigo": 1 },
  { "label": "Hospitalización Obstetricia-Ginecología", "value": "Hospitalización Obstetricia-Ginecología", "codigo": 1 },
  { "label": "Atención Hospitalaria Especialidades (oncología, Neurología, otros)", "value": "Atención Hospitalaria Especialidades (oncología, Neurología, otros)", "codigo": 2 },
  { "label": "Unidad de Cuidados Intensivos", "value": "Unidad de Cuidados Intensivos", "codigo": 3 },
  { "label": "Unidad de Tratamiento Intermedio", "value": "Unidad de Tratamiento Intermedio", "codigo": 3 },
  { "label": "Unidad hospitalización Neonatología", "value": "Unidad hospitalización Neonatología", "codigo": 3 },
  { "label": "Unidad de Urgencia", "value": "Unidad de Urgencia", "codigo": 4 },
  { "label": "Pabellón- Recuperación", "value": "Pabellón- Recuperación", "codigo": 5 },
  { "label": "Laboratorio Clínico", "value": "Laboratorio Clínico", "codigo": 6 },
  { "label": "Imagenología", "value": "Imagenología", "codigo": 6 },
  { "label": "Farmacia", "value": "Farmacia", "codigo": 6 },
  { "label": "Alimentación", "value": "Alimentación", "codigo": 6 },
  { "label": "Esterilización", "value": "Esterilización", "codigo": 6 },
  { "label": "Odontología", "value": "Odontología", "codigo": 8 },
  { "label": "Unidad de Diálisis", "value": "Unidad de Diálisis", "codigo": 6 },
  { "label": "Radioterapia", "value": "Radioterapia", "codigo": 6 },
  { "label": "Rehabilitación y kinesioterapia", "value": "Rehabilitación y kinesioterapia", "codigo": 6 },
  { "label": "Apoyo administrativo (recepción, admisión, secretarias)", "value": "Apoyo administrativo (recepción, admisión, secretarias)", "codigo": 7 },
  { "label": "Gerencia - Subgerencias - Dirección", "value": "Gerencia - Subgerencias - Dirección", "codigo": 7 },
  { "label": "Atención Ambulatoria", "value": "Atención Ambulatoria", "codigo": 8 },
  { "label": "Unidad de Medicina Transfusional (UMT)", "value": "Unidad de Medicina Transfusional (UMT)", "codigo": 6 },
  { "label": "Unidad de donantes", "value": "Unidad de donantes", "codigo": 6 },
  { "label": "Centro de sangre", "value": "Centro de sangre", "codigo": 6 },
  { "label": "Transporte de paciente", "value": "Transporte de paciente", "codigo": 7 }
]

const relacion_laboral_list = [
  { "label": "Permanente", "value": "Permanente" },
  { "label": "Transitoria", "value": "Transitoria" },
  { "label": "Interconsultor de llamada", "value": "Interconsultor de llamada" }
]

const lista_tipo_jornada = ["11 horas", "22 horas", "33 horas", "44 horas", "Turno de llamada", "Otros"]

const ModalCreatePersonel = props => {

  const {
    openDialog = false,
    close,
    //selectedRut = '',
    selectedRow = '',
    isEdit = false,
    setSelectedRow,
    // antiguedades,
    contratos,
    profesiones,
    jornadas,
    unidadesList,
    sexos,
    reload,

  } = props;
  const [loading, setIsLoading] = useState(false)
  const classes = addStyle()

  const [rut, setRut] = useState('')
  const [nombre, setNombre] = useState('')
  const [ap_paterno, setAp_paterno] = useState('')
  const [ap_materno, setAp_materno] = useState('')
  const [genero, setGenero] = useState(null)
  const [profesion, setProfesion] = useState('')
  const [nRegistroSuper, setNRegistroSuper] = useState('')
  const [tipoJornada, setTipoJornada] = useState('')
  const [tipoContrato, setTipoContrato] = useState('')
  const [antiguedad, setAntiguedad] = useState('')
  const [fechaContrato, setFechaContrato] = useState('')
  const [unidadFuncional, setUnidadFuncional] = useState('')
  //const [isEditing, setIsEditing] = useState(true)
  const [telefono, setTelefono] = useState('')
  const [correo, setCorreo] = useState('')
  const [objetorConciencia, setObjetorConciencia] = useState('')

  useEffect(() => {

    if (selectedRow !== '') {
      console.log('tipocont',selectedRow.tipo_contrato)
      setRut(formatRut(selectedRow.rut))
      setNombre(selectedRow.persona.nombres)
      setAp_paterno(selectedRow.persona.apellido_paterno)
      setAp_materno(selectedRow.persona.apellido_materno)
      setGenero(selectedRow.persona.id_sexo ? selectedRow.persona.id_sexo : null)
      setProfesion(selectedRow.profesion ? selectedRow.profesion : '')
      setNRegistroSuper(selectedRow.n_registro_super ? selectedRow.n_registro_super+"" : '')
      setTipoJornada(selectedRow.tipo_jornada)
      setTipoContrato(selectedRow.tipo_contrato)
      setUnidadFuncional(selectedRow.unidad_funcional_desempeño)
      setAntiguedad(selectedRow.relacion_laboral)
      setFechaContrato(selectedRow.fecha_contrato ? selectedRow.fecha_contrato : '')
      setCorreo(selectedRow.correo)
      setTelefono(selectedRow.persona.tlf_movil)
      if (selectedRow.persona.objetor_conciencia) {
        setObjetorConciencia("si")
      } else {
        setObjetorConciencia("no")
      }


    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow])

  const onCloseDialog = (event, reason) => {

    if (reason !== 'backdropClick') {
      clearData()
      close();
    }

  };

  const formatRut = (rut) => {
    rut = rut.replace(/[^\dKk]/g, '').toUpperCase();
    let number = rut.slice(0, -1);
    let verifier = rut.slice(-1);
    number = number.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return number + '-' + verifier;
  };

  const handleRutChange = (event) => {
    let inputRut = event.target.value;
    inputRut = inputRut.slice(0, 13);
    const formattedRut = formatRut(inputRut);
    setRut(formattedRut);
    if (event.target.value.length > 9 && validateRut(formattedRut)) {
      handleBlur(formattedRut)
    }

  };

  const validateRut = (rut) => {
    if (!rut || rut.length < 3) return false;

    const cleanRut = rut.replace(/[.-]/g, '');
    const rutNumber = cleanRut.slice(0, -1);
    const rutVerifier = cleanRut.slice(-1).toUpperCase();
    let sum = 0;
    let mul = 2;

    for (let i = rutNumber.length - 1; i >= 0; i--) {
      sum += parseInt(rutNumber[i], 10) * mul;
      mul = (mul + 1) % 8 || 2;
    }

    const expectedVerifier = (11 - (sum % 11)).toString();
    const verifier = expectedVerifier === '11' ? '0' : expectedVerifier === '10' ? 'K' : expectedVerifier;

    return verifier === rutVerifier;
  };

  const handleBlur = (rut) => {


    if (validateRut(rut)) {
      //const cleanRut = rut.replace(/[.-]/g, '');
      //const rutNumber = cleanRut.slice(0, -1);
      getPrestadorPorRut(rut)
        .then(res => {
          setNombre(res.data.nombres ? res.data.nombres : '')
          setAp_paterno(res.data.apellido_paterno ? res.data.apellido_paterno : '')
          setAp_materno(res.data.apellido_materno ? res.data.apellido_materno : '')
          setGenero(res.data.sexo ? transformGenderToSexId(res.data.sexo) : 'seleccione')
          setNRegistroSuper(res.data.nro_registro ? res.data.nro_registro+'' : '')
          setProfesion(res.data.antecedentes[0].cod_antecedente ? res.data.antecedentes[0].cod_antecedente : '')
          toast.success('Datos del prestador cargados correctamente.')

        })
        .catch(e => {
          console.error(e)
          toast.error('No se encontró registro del prestador en el RNPI.')
        })
        .finally(f => {

        })
    } else {
      toast.error('El rut ingresado no es válido.')
      clearData2()
    }

  };

  /*   const normalizeString = (str) => {
      return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    } */

  const getprofesion = (prof) => {

    let profesionesAux = profesiones.map((item) => {
      return item.profesion
    })

    let result = findMostSimilarString(prof, profesionesAux)
    let result2 = profesiones.find(obj => obj.profesion === result)

    return result2.id
  }

  const clearData = () => {
    if (isEdit) {
      setSelectedRow('')
      // setIsEditing(false)
    }
    setRut('')
    setNombre('')
    setAp_paterno('')
    setAp_materno('')
    setGenero('')
    setProfesion('')
    setNRegistroSuper('')
    setTipoJornada('')
    setTipoContrato('')
    setAntiguedad('')
    setFechaContrato('')
    setUnidadFuncional('')
  }

  const clearData2 = () => {
    if (isEdit) {
      setSelectedRow('')
      // setIsEditing(false)
    }

    setNombre('')
    setAp_paterno('')
    setAp_materno('')
    setGenero('')
    setProfesion('')
    setNRegistroSuper('')
    setTipoJornada('')
    setTipoContrato('')
    setAntiguedad('')
    setFechaContrato('')
    setUnidadFuncional('')
  }

  /*   const handleEdit = () => {
  
      if (isEditing) {
        postCreatePersonel("act")
      } else {
        setIsEditing(!isEditing)
      }
    } */

  const postCreatePersonel = (act) => {

    setIsLoading(true)

    const cleanRut = rut.replace(/[.-]/g, '');
    const rutNumber = cleanRut.slice(0, -1);
    const rutVerifier = cleanRut.slice(-1).toUpperCase();

    let data = {
      "id_ficha_tecnica": sessionStorage.getItem('idFicha'),
      "rut": rutNumber,
      "dv": rutVerifier,
      "nombres": nombre,
      "apellido_paterno": ap_paterno,
      "apellido_materno": ap_materno,
      "nro_registro": nRegistroSuper,
      "id_profesion": profesion,
      "id_sexo": genero,
      "tipo_jornada": tipoJornada,
      "tipo_contrato": tipoContrato,
      "annio_antiguedad": antiguedad,
      "fecha_contrato": fechaContrato,
      //"annio_antiguedad": 1,
      "unidad_funcional": unidadFuncional.toUpperCase(),
      "tlf_movil": telefono,
      "correo": correo,
      "objetor_conciencia": objetorConciencia === "si" ? true : false

    }


    postCrearPersonl(data)
      .then(res => {
        if (act) {
          toast.success('Personal editado con éxito')
        } else {
          toast.success('Personal creado con éxito')
        }

      })
      .catch(e => {
        console.error(e)
        toast.error('Ocurrió un problema')
      })
      .finally(f => {
        setIsLoading(false)
        if (!act) {
          //onCloseDialog()
        } else {
          //  setIsEditing(!isEditing)
        }
        onCloseDialog()
        reload()
      })
  }

  const handleChangeText = (val, setter) => {
    setter(val)
  }

  const transformGenderToSexId = (gender) => {
    if (gender === "Femenino") {
      return 2
    }

    else if (gender === "Masculino") {
      return 1
    } else {
      return 3
    }
  }

  const isReadyToPost = () => {
    let isReady = false

    if (
      getHelperTextRut(rut) === '' &&
      // getHelperTextMail(correo) === '' &&
      // getHelperTextSelect(genero) === '' &&
      getHelperTextSelect(profesion) === '' &&
      getHelperTextSelect(tipoJornada) === '' &&
      getHelperTextSelect(tipoContrato) === '' &&
      getHelperTextSelect(antiguedad) === '' &&
      getHelperTextDate(fechaContrato) === '' &&
      getHelperTextTextInput(unidadFuncional) === '' &&
      getHelperTextTextInput(nombre) === '' &&
      getHelperTextTextInput(ap_paterno) === '' &&
      getHelperTextTextInput(ap_materno) === '' &&
      //getHelperTextTextInput(nRegistroSuper) === '' &&
      // getHelperTextTextInput(telefono) === '' &&
      getHelperTextTextInput(objetorConciencia) === ''
      // telefono?.length === 12
    ) {
      isReady = true
    }

    return isReady
  }

  const getHelperTextRut = () => {
    if (rut === '') {
      return 'Campo obligatorio'
    } else if (!validateRut(rut)) {
      return 'RUT inválido'
    } else {
      return ''
    }
  }

  const getHelperTextMail = () => {
    if (correo === '') {
      return 'Campo obligatorio'
    } else if (!validateMail(correo)) {
      return 'Correo inválido'
    } else {
      return ''
    }
  }

  const getHelperTextTextInput = (field) => {
    if (field === '') {
      return 'Campo obligatorio'
    } else {
      return ''
    }
  }

  const getHelperTextDate = (field) => {
    if (field === '') {
      return 'Campo obligatorio'
    } else {
      return ''
    }
  }

  const getHelperTextSelect = (field) => {

    if (field === '' || field + ''.toLowerCase() === 'seleccione') {
      return 'Campo obligatorio'
    } else {
      return ''
    }
  }

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}>
        <Grid container justifyContent='space-between'>
          <Grid item >
            {!isEdit ? "Agregar Personal" : "Ver Personal"}
          </Grid>


        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>
            <Grid item xs={12} sm={12}>
              <AppTextInput
                error={!validateRut(rut)}
                fullWidth
                variant="outlined"
                label="Rut"
                value={rut}
                onChange={(e) => {
                  handleRutChange(e)
                }}
                //onBlur={handleBlur}

                helperText={getHelperTextRut()}
              />
            </Grid>
            <Grid item xs={6} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Nombre"
                value={nombre}
                onChange={(e) => {
                  if (e.target.value.length < 100) {
                    handleChangeText(e.target.value, setNombre)
                  }

                }}

                helperText={getHelperTextTextInput(nombre)}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Apellido Paterno"
                value={ap_paterno}
                onChange={(e) => {
                  if (e.target.value.length < 100) {
                    handleChangeText(e.target.value, setAp_paterno)
                  }
                }}

                helperText={getHelperTextTextInput(ap_paterno)}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Apellido Materno"
                value={ap_materno}
                onChange={(e) => {
                  if (e.target.value.length < 100) {
                    handleChangeText(e.target.value, setAp_materno)
                  }
                }}

                helperText={getHelperTextTextInput(ap_materno)}
              />
            </Grid>

                        <Grid item xs={6} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Profesión"
                value={profesion}
                onChange={(e) => {
                  if (e.target.value.length < 100) {
                    handleChangeText(e.target.value, setProfesion)
                  }
                }}

                helperText={getHelperTextTextInput(ap_materno)}
              />
            </Grid>


{/*             <Grid item xs={6} sm={6}>

              <FormControl size='small' fullWidth>
                <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Profesión"}
                </InputLabel>
                <Select

                  error={(profesion === '' || profesion === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Profesión"}
                  value={profesion}
                  onChange={(e) => { setProfesion(e.target.value) }}

                >
                  {profesiones.map((option, index) => (
                    <option key={index} value={option.id}>
                      {option.profesion}
                    </option>
                  ))}
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(profesion)}
                </FormHelperText>
              </FormControl>
            </Grid> */}

            <Grid item xs={6} sm={6}>
              <AppTextInput
                fullWidth
                variant="outlined"
                label="Nº Registro"
                value={nRegistroSuper}
                onChange={(e) => {
                  const regex = /^[0-9]+$/;
                  if ((regex.test(e.target.value) || e.target.value === '') && e.target.value.length < 12) {
                    handleChangeText(e.target.value, setNRegistroSuper)
                  }

                }}

              //helperText={getHelperTextTextInput(nRegistroSuper)}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <FormControl size='small' fullWidth>
                <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Tipo jornada"}
                </InputLabel>
                <Select

                  error={(tipoJornada === '' || tipoJornada === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Tipo jornada"}
                  value={tipoJornada}
                  onChange={(e) => { setTipoJornada(e.target.value) }}

                >
                  {

                    lista_tipo_jornada.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))
                  }
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(tipoJornada)}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6}>
              <FormControl size='small' fullWidth>
                <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Tipo Contrato"}
                </InputLabel>
                <Select

                  error={(tipoContrato === '' || tipoContrato === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Tipo Contrato"}
                  value={tipoContrato}
                  onChange={(e) => { setTipoContrato(e.target.value) }}

                >
                  {contratos.map((option, index) => (
                    <option key={index} value={option.tipo_contrato}>
                      {option.tipo_contrato}
                    </option>
                  ))}
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(tipoContrato)}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6}>
              <FormControl size='small' fullWidth>
                <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Relación laboral"}
                </InputLabel>
                <Select

                  error={(antiguedad === '' || antiguedad === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Años Antigüedad"}
                  value={antiguedad}
                  onChange={(e) => { setAntiguedad(e.target.value) }}

                >
                  <option key={'00'} value={'seleccione'}>
                    Seleccione
                  </option>
                  {relacion_laboral_list.map((option, index) => (
                    <option key={index} value={option.label}>
                      {
                        //option.id < 2 ? option.id + ' Año' : option.id + ' Años'
                        option.label
                      }
                    </option>
                  ))}
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(antiguedad)}
                </FormHelperText>
              </FormControl>
            </Grid>

            <Grid item xs={6} sm={6}>
              <AppTextInput
                error={getHelperTextDate(fechaContrato) !== ''}
                fullWidth
                variant="outlined"
                label="Fecha de contrato"
                type="date"
                value={fechaContrato}
                onChange={(e) => {
                  handleChangeText(e.target.value, setFechaContrato)
                }}
                helperText={getHelperTextDate(fechaContrato)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={6} sm={6}>
              <FormControl size='small' fullWidth>
                <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Unidad de atención"}
                </InputLabel>
                <Select

                  error={(unidadFuncional === '' || unidadFuncional === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Unidad de atención"}
                  value={unidadFuncional}
                  onChange={(e) => {
                    setUnidadFuncional(e.target.value)
                    console.log(e.target.value)
                  }
                  }

                >
                  <option key={'00'} value={'seleccione'}>
                    Seleccione
                  </option>
                  {unidad_funcional_list.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(unidadFuncional)}
                </FormHelperText>
              </FormControl>
              {/*               <AppTextInput
                fullWidth
                variant="outlined"
                label="Unidad de atención"
                //value={unidadFuncional}
                value={unidadFuncional}
                onChange={(e) => {
                  setUnidadFuncional(e.target.value)

                }}

                helperText={getHelperTextTextInput(unidadFuncional)}
              /> */}
            </Grid>

            {/*             <Grid item xs={6} sm={6}>
              <FormControl size='small' fullWidth>
                <InputLabel
                  htmlFor="grouped-native-select"
                  style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                  {"Unidad funcional"}
                </InputLabel>
                <Select

                  error={(unidadFuncional === '' || unidadFuncional + ''.toLowerCase() === 'seleccione') ? true : false}
                  native
                  id="grouped-native-select"
                  fullWidth
                  variant='outlined'
                  label={"Unidad funcional"}
                  value={unidadFuncional}
                  onChange={(e) => { setUnidadFuncional(e.target.value) }}

                >
                  {unidadesList.map((option,index) => (
                    <option key={index} value={option.id}>
                      {option.value}
                    </option>
                  ))}
                </Select>
                <FormHelperText style={{ color: 'red' }}>
                  {getHelperTextSelect(unidadFuncional)}
                </FormHelperText>
              </FormControl>

            </Grid> */}





            <Grid item xs={6} sm={6}>
              <FormControl error={objetorConciencia === '' ? true : false}>
                <FormLabel id="demo-radio-buttons-group-label">Objetor de conciencia</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="Objetor de conciencia"
                  name="radio-buttons-group"
                  value={objetorConciencia}
                  onChange={(e) => { setObjetorConciencia(e.target.value) }}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Si" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />

                </RadioGroup>
                <FormHelperText>
                  {getHelperTextTextInput(objetorConciencia)}
                </FormHelperText>
              </FormControl>

            </Grid>

          </GridContainer>
        </Box>

        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            {!isEdit ? "Cancelar" : "Cerrar"}
          </Button>
          <Box ml={2}>
            {!isEdit ? <Button variant="outlined" color="primary" onClick={() => { postCreatePersonel() }} disabled={loading || !isReadyToPost()}>
              <Save style={{ marginRight: 10 }} />
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Agregar'}
            </Button>
              :
              <Button variant="outlined" color="primary" onClick={() => { postCreatePersonel("act") }} disabled={loading || !isReadyToPost()}>
                <Save style={{ marginRight: 10 }} />
                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Guardar'}
              </Button>
            }

          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ModalCreatePersonel;